import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import SentimentDetail from './SentimentDetail';
import SentimentBreakdown from './SentimentBreakdown';

class RecordAgentSentimentModal extends React.PureComponent {
  constructor(props) {
    super(props);

    const agentSentiment = props.record.agent_sentiment || {};
    this.state = { agentSentiment };
  }

  render() {
    const { agentSentiment } = this.state;
    const {
      toggle,
      focusedId,
      record,
    } = this.props;

    return (
      <Modal
        isOpen={focusedId === record.contact_id}
        toggle={toggle}
        className="mt-6"
        zIndex="100000"
      >
        <ModalHeader className="text-capitalize">
          {`Agent Sentiment: ${record.agent_first_name} ${record.agent_last_name}`}
        </ModalHeader>
        <ModalBody className="text-center">
          <h5>
            <span>Overall Sentiment: </span>
            <SentimentDetail score={agentSentiment.Sentiment} />
          </h5>
          <div className="py-0">
            <SentimentBreakdown scores={agentSentiment.SentimentScore} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="white" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  focusedId: store.records.agentSentimentModalId,
});

const mapDispatchToProps = {
  toggle: () => ({ type: 'TOGGLE_RECORD_AGENT_SENTIMENT' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordAgentSentimentModal);
